<template>	
  <div class="info-notification">	
    <icon class="info-notification__icon" fill="rgb(6, 118, 159)" type="info-circle"></icon>

    <div class="info-notification__content">
      <af-h4>	
        <slot name="title"></slot>	
      </af-h4>	
      <slot name="content"></slot>	
    </div>
  </div>	
</template>	
	
<script>	
import Icon from '@/components/Icon'	
import AfH4 from '@/components/AfH4'	
	
export default {	
  name: 'ProfileInfo',	
  components: {	
    Icon,	
    AfH4	
  },	
  props: {	
    onLinkClick: Function	
  }	
}	
</script>	
	
<style lang="postcss" scoped>
.info-notification {
  background-color: var(--color-link-water);
  border: solid 1px var(--color-mint-tulip);
  border-radius: 4px;
  display: flex;
  padding: 15px;
}

.info-notification__icon {
  align-self: flex-start;
  margin-right: 15px;
}

.info-notification__content {
  flex: 1;

  & p:first-of-type {
    margin-top: 0;
  }

  & p:last-of-type {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AfInformationNotification.vue